import { useMutation } from "react-query";
import { login } from "../../../../api/User";
import { useMultiStepFormContext } from "../../../context/MultiStepFormContext/MultiStepFormContext";
import { toast } from "react-toastify";


export const useLogin = () => {
    const {nextFormStep , updateFormData} = useMultiStepFormContext();
    return {
        ...useMutation(login, {
            onSuccess: (res) => {
                nextFormStep();
                updateFormData({...res});
                
            },
        onError: (error: any) => {
            if (error.response?.data?.message) {
                toast.error(error.response?.data?.message);
                return
            }
            if (error.response?.data?.error) {
                toast.error(error.response?.data?.error);
                return
            }
            toast.error("Something went wrong! Please try again later.");
        },
        }),
    };
};